import { initState as initDimensionState } from "@reducers/selectors/dimension";

import {
  RESET_NAIL,
  SET_NAIL_OPTIONS,
  SET_NAIL_STATE
} from '@reducers/options/nail/actions';
import {mergeDeep} from "../../../services/helper.service";
import { APP_TYPES } from '@config';

export const initialState = {
  diameter: initDimensionState[APP_TYPES.WOOD_CONNECTION].nailsConfiguration.diameter,
  n: initDimensionState[APP_TYPES.WOOD_CONNECTION].nailsConfiguration.n, 
  p: initDimensionState[APP_TYPES.WOOD_CONNECTION].nailsConfiguration.p,
  spacings: {
    s1: initDimensionState[APP_TYPES.WOOD_CONNECTION].nailsConfiguration.spacings.s1,
    s2: initDimensionState[APP_TYPES.WOOD_CONNECTION].nailsConfiguration.spacings.s2,
    s3: initDimensionState[APP_TYPES.WOOD_CONNECTION].nailsConfiguration.spacings.s3,
    s4: initDimensionState[APP_TYPES.WOOD_CONNECTION].nailsConfiguration.spacings.s4,
    s5: initDimensionState[APP_TYPES.WOOD_CONNECTION].nailsConfiguration.spacings.s5,
    c1Top: initDimensionState[APP_TYPES.WOOD_CONNECTION].nailsConfiguration.spacings.c1Top,
    c2Top: initDimensionState[APP_TYPES.WOOD_CONNECTION].nailsConfiguration.spacings.c2Top,
    c3Top: initDimensionState[APP_TYPES.WOOD_CONNECTION].nailsConfiguration.spacings.c3Top,
    c4Top: initDimensionState[APP_TYPES.WOOD_CONNECTION].nailsConfiguration.spacings.c4Top,
    c5Top: initDimensionState[APP_TYPES.WOOD_CONNECTION].nailsConfiguration.spacings.c5Top,
  }
};

export default (state = mergeDeep({}, initialState), action) => {
  switch (action.type) {
    case RESET_NAIL: {
      return mergeDeep({}, initialState);
    }
    case SET_NAIL_STATE: {
      return action.state;
    }
    case SET_NAIL_OPTIONS: {
      const updatedState = mergeDeep({}, state, action.options);
      return updatedState;
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/options/nail/index.js